export default "<div *ngIf=\"message\" >\r\n      <ngb-alert [type]=\"message.type\" (close)=\"close(alert)\">{{ message.text }}</ngb-alert>\r\n  </div>\r\n";